/* eslint-disable no-mixed-operators */
import React, { useEffect, useState } from 'react'
import classNames from 'classnames'
import { Dropdown, Ul, Li } from 'meinian-package/src/baseComponent'
import Icon from 'meinian-package/src/component/icon'
import Input from 'meinian-package/src/baseComponent/input'

export default (props) => {
  const { onChange, placement = 'bottomRight', ulStyle, overlayStyle, ...otherProps } = props
  const [visible, setVisible] = useState(false)
  const onOk = (val) => {
    onChange && onChange(val)
    setVisible(true)
  }
  const onClear = () => {
    onChange && onChange(null)
    setVisible(false)
  }
  return <Dropdown
    overlayStyle={overlayStyle}
    overlay={<List
      {...otherProps}
      onChange={onOk}
      onOk={onOk}
      onClear={onClear}
      visible={visible}
      style={ulStyle}
    />}
    visible={visible}
    onVisibleChange={_visible => setVisible(_visible)}
    placement={placement}
  >
    <span><SelectDisplay {...otherProps} visible={visible} onClear={onClear} /></span>
  </Dropdown>
}
const List = (props) => {
  const { className, style, data = [], value = null, onChange, readOnly, onMouseEnter } = props
  const onRange = (_value) => {
    onChange && onChange(_value)
  }
  return <Ul className={className} style={{ maxHeight: 500, ...style }}>
    {data?.map(item => <Li
      active={value?.[0] === item.value[0] && value?.[1] === item.value[1]}
      disabled={item.disabled}
      readOnly={readOnly}
      onClick={() => {
        onChange && onChange(item.value)
      }}
      onMouseEnter={e => onMouseEnter && onMouseEnter(item.value, e)}
    >{item.label}</Li>)}
    <Input
      wrapStyle={{ width: '80px', height: '30px', background: '#fff', border: '1px solid var(--m-fill-3)', margin: '0 0 10px 10px' }}
      value={value?.[0]}
      onChange={e => onRange([e.target.value, value?.[1]])}
    /> - <Input
      value={value?.[1]}
      wrapStyle={{ width: '80px', height: '30px', background: '#fff', border: '1px solid var(--m-fill-3)', margin: '0 10px 10px 0 ' }}
      onChange={e => onRange([value?.[0], e.target.value])}
    />
  </Ul>
}

export const SelectDisplay = (props) => {
  const { className, displayStyle, value = null, placeholder = '请选择', visible, inner, onClear, allowClear = true, prefix } = props
  const [text, setText] = useState('')
  // const [newValue, setNewValue] = useState(value)
  useEffect(() => {
    if (value?.length) {
      if (value[0] && value[1]) {
        setText(`${value[0]}~${value[1]}`)
      } else if (!value[0]) {
        if (!value[0] && !value[1]) {
          setText(placeholder)
        } else {
          setText(`0~${value[1]}`)
        }
      } else if (!value[1]) {
        if (!value[0] && !value[1]) {
          setText(placeholder)
        } else {
          setText(`${value[0]}以上`)
        }
      }
    } else {
      setText(placeholder)
    }
  }, [value])

  return <span className={classNames('meinian-select-display', className, { visible, active: (value && (value[0] || value[1]) || value === 0) && allowClear, inner })} style={displayStyle}>
    <span className="line-1">{prefix}{text}</span>
    {visible ? <Icon type="m-Vxing_shang" /> : <Icon type="m-Vxing_xia" />}
    {(value && (value[0] || value[1])) && allowClear ? <Icon type="m-Vxing_shang" className="clear-icon" onClick={(e) => { e && e.stopPropagation(); onClear() }} /> : null}
  </span>
}
